import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const Facebook = forwardRef<SVGSVGElement, IconProps>(({ color = 'currentColor', size = 16 }, forwardedRef) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={forwardedRef}
    >
      <path
        d="M14.9808 7.9989C14.9806 6.66121 14.5971 5.35159 13.8757 4.22509C13.1544 3.09858 12.1253 2.20236 10.9104 1.64252C9.6955 1.08268 8.34562 0.882677 7.02058 1.06618C5.69554 1.24968 4.45082 1.80901 3.43378 2.67794C2.41675 3.54688 1.66998 4.68903 1.2819 5.96919C0.89381 7.24934 0.880656 8.6139 1.24399 9.9013C1.60732 11.1887 2.33193 12.345 3.33203 13.2334C4.33212 14.1218 5.56583 14.705 6.88708 14.914V10.0228H5.10996V7.9989H6.88708V6.45715C6.88708 4.7019 7.93184 3.73328 9.53133 3.73328C10.297 3.73328 11.0976 3.86978 11.0976 3.86978V5.59265H10.2156C9.34583 5.59265 9.07458 6.13253 9.07458 6.6864V7.9989H11.0162L10.7056 10.0228H9.07458V14.914C10.7211 14.6532 12.2205 13.8135 13.3032 12.5459C14.3859 11.2782 14.9807 9.66594 14.9808 7.9989Z"
        fill="#1877F2"
      />
      <path
        d="M11.0162 7.99893H9.07461V6.68643C9.07461 6.13256 9.34586 5.59268 10.2156 5.59268H11.0976V3.86981C11.0976 3.86981 10.297 3.73331 9.53136 3.73331C7.93186 3.73331 6.88711 4.70281 6.88711 6.45718V7.99893H5.10999V10.0228H6.88711V14.9141C7.24894 14.9707 7.61463 14.9991 7.98086 14.9989C8.34709 14.9991 8.71278 14.9707 9.07461 14.9141V10.0228H10.7056"
        fill="white"
      />
    </svg>
  )
})

export default Facebook
